import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {ActiveListSingleVoyagesLazy} from "@containers/singleVoyage/activeVoyages/ActiveListSingleVoyages.lazy";

const ActiveSingleVoyagesPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ActiveListSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ActiveSingleVoyagesPage;